import { render, staticRenderFns } from "./SampleReply.vue?vue&type=template&id=4480d1c3"
import script from "./SampleReply.vue?vue&type=script&lang=js"
export * from "./SampleReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports